/**
 * Template variables shared by the settings HTML editors.
 *
 * The token list used to live twice in every editor: once as a wall of <p>
 * tags describing it, and again inside parseHtmlVariables as a chain of
 * if-statements. The two had drifted — {{verify_url}} and {{items_table}} were
 * substituted but never documented, and three invoice variables were all
 * described as "this will inject the Invoice Status". One list per editor now
 * drives both the chips and the preview.
 */
export type TemplateVariable = {
    /** The literal token, including braces. */
    token: string,
    /** What it is replaced with when the email is actually sent. */
    description: string,
};

/**
 * Substitute every known token with its sample value.
 *
 * Uses replaceAll throughout. The old email editor used replace() for
 * {{name}}, so a template mentioning the recipient twice only ever had the
 * first mention filled in when previewed.
 */
export function applyTemplateSamples(html: string, samples: Record<string, string>): string {
    let output: string = html;
    for (const token of Object.keys(samples)) {
        output = output.replaceAll(token, samples[token]);
    }
    return output;
}

/** One randomised-but-consistent person, so name, email and avatar agree. */
export type SamplePerson = {
    name: string,
    email: string,
    image: string,
};

export function samplePerson(hostUrl: string): SamplePerson {
    const people: SamplePerson[] = [
        {
            name: 'Jane Doe',
            email: 'jane.doe@noknok.ai',
            image: hostUrl + 'images/admin/nok/email/signature/defaults/female-placeholder.png',
        },
        {
            name: 'John Doe',
            email: 'john.doe@noknok.ai',
            image: hostUrl + 'images/admin/nok/email/signature/defaults/male-placeholder.png',
        },
    ];
    return people[Math.floor(Math.random() * people.length)];
}
